/**
 * Converts a nested object to Strapi's LHS bracket-notation query string.
 *
 * Example:
 *   toStrapiParams({ populate: { seo: { populate: { ogImage: '*' } } } })
 *   => 'populate%5Bseo%5D%5Bpopulate%5D%5BogImage%5D=*'
 *
 * Do NOT use Angular HttpParams -- it cannot produce nested bracket notation.
 */
export function toStrapiParams(obj: Record<string, unknown>): string {
  const pairs: string[] = [];

  function flatten(current: unknown, prefix: string): void {
    if (current === null || current === undefined) return;

    if (Array.isArray(current)) {
      current.forEach((item, i) => flatten(item, `${prefix}[${i}]`));
    } else if (typeof current === 'object') {
      Object.entries(current as Record<string, unknown>).forEach(([key, val]) => {
        flatten(val, prefix ? `${prefix}[${key}]` : key);
      });
    } else {
      pairs.push(`${encodeURIComponent(prefix)}=${encodeURIComponent(String(current))}`);
    }
  }

  flatten(obj, '');
  return pairs.join('&');
}
